import React from "react";
import LobbyModal from './LobbyModal'
import {setGlobalValue} from "../redux-actions/global-actions.js";
import OptinForm from "../battle-optin/OptinForm";
import {getEnvelopeSvg} from '../battle-optin/get-envelope-svg'

class HomeEmailModal extends React.Component {

  constructor() {
    super();
    this.state = {
      hasBeenSubmitted: false
    }
  }

  handleModalClose() {
    //Close the modal
    setGlobalValue({isHomeEmailModalOpen: false});
  }

  handleSubmissionSuccess() {
    //Say THANK YOU! Then close the modal.
    this.setState({
      hasBeenSubmitted: true
    }, () => {
      setTimeout(() => {
        //Then close...
        setGlobalValue({isHomeEmailModalOpen: false});
      }, 1000)
    });
  }

  renderSuccessState() {
    const style = {
      textAlign: "center",
      fontSize: "2em"
    };
    return (
      <div style={style}>Thank you!</div>
    )
  }


  render() {
    return (
      <LobbyModal
        title="Email Signup"
        handleCloseCallback={this.handleModalClose.bind(this)}
      >
        <div>
          {/*<h3 className="Modal__title">Join the Crew</h3>*/}
          {
            getEnvelopeSvg({
              width: "8em",
              display: "block",
              margin: "0 auto 1em"
            }, "EmailOptinEnvelope")
          }
          <p className="Modal__paragraph" style={{marginBottom: "3em"}}>
            The full version of The Danger Crew is still in development, but we'll email you when it is ready!
          </p>
          {
            this.state.hasBeenSubmitted
              ? this.renderSuccessState() : (
                <OptinForm
                  successCallback={this.handleSubmissionSuccess.bind(this)}
                />
              )
          }
        </div>
      </LobbyModal>
    );
  }
}

export default HomeEmailModal;



// WEBPACK FOOTER //
// ./src/b5-home/HomeEmailModal.js